import DiagramConst from "~/helpers/workareaDiagram/diagramConst";

export default class WorkflowConst extends DiagramConst {
  // This needs to stay identical to WorkflowConst in workflow_steps_steps.rb in order for tests
  // to calculate the location to click correctly

  // Start
  static readonly StartHeight = 34;
  static readonly StartStrokeWidth = 1;
  static readonly StartYOffset = 4;
  static readonly StartCornerRadius = 5;
  static readonly StartArrowLength = 20;

  static startTotalYOffset() {
    return WorkflowConst.StartYOffset + WorkflowConst.StartHeight + WorkflowConst.StartStrokeWidth * 2 +
      WorkflowConst.StartArrowLength + WorkflowConst.ArrowPointerLength;
  }

  static readonly StepHeight: number = 153;
  static readonly StepWidth: number = 436;

  // End Step
  static readonly EndStepHeight = 50;
  static readonly EndStepWidth = 187;
  static readonly EndStepBorderWidth = 1;
  static readonly EndStepPaddingOffset = 250;

  static readonly DisconnectedStepYOffset = WorkflowConst.StepHeight;

  // Arrow with plus
  static readonly PlusLineLength = 55;
  static readonly PlusLength = 16;
  static readonly LineStrokeWidth = 4;
}